import {Injectable} from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanLoad,
    Route,
    Router,
    RouterStateSnapshot,
    UrlSegment,
    UrlTree
} from '@angular/router';
import {Observable, of} from 'rxjs';
import {PermissionsService} from '@src/app/core/services/permissions.service';

@Injectable({
    providedIn: 'root'
})
export class PermissionGuard implements CanActivate, CanActivateChild, CanLoad {
    /**
     * Constructor
     */
    constructor(
        private permissionService: PermissionsService,
        private router: Router,
    ) {
    }

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.can(route.data.permission, state.url);
    }

    public canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.can(childRoute.data.permission, state.url);
    }

    public canLoad(
        route: Route,
        segments: UrlSegment[]
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.can(route.data.permission, '/');
    }

    private can(permission: string | string[] | undefined, redirectUrl: string): Observable<boolean> {
        const hasPermission = Array.isArray(permission)
            ? permission.some(item => this.permissionService.can(item))
            : !permission || this.permissionService.can(permission);

        if (!hasPermission) {
            this.router.navigate(['login'], {queryParams: {redirectUrl}}).then(r => r);
            return of(false);
        }

        return of(true);
    }
}
